export class UpdateQuoteServicesMessage { 
  quoteServiceIds: number[]

  constructor(quoteServiceIds: number[]) {
    this.quoteServiceIds = quoteServiceIds
  }
}